import _objectSpread from "/var/www/commonsku/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { display, addEventListener, buildEndpointHost } from '@datadog/browser-core';
var REMOTE_CONFIGURATION_VERSION = 'v1';
export function fetchAndApplyRemoteConfiguration(initConfiguration, callback) {
  fetchRemoteConfiguration(initConfiguration, function (remoteInitConfiguration) {
    callback(applyRemoteConfiguration(initConfiguration, remoteInitConfiguration));
  });
}
export function applyRemoteConfiguration(initConfiguration, remoteInitConfiguration) {
  return _objectSpread(_objectSpread({}, initConfiguration), remoteInitConfiguration);
}
export function fetchRemoteConfiguration(configuration, callback) {
  var xhr = new XMLHttpRequest();
  addEventListener(configuration, xhr, 'load', function () {
    if (xhr.status === 200) {
      var remoteConfiguration = JSON.parse(xhr.responseText);
      callback(remoteConfiguration.rum);
    } else {
      displayRemoteConfigurationFetchingError();
    }
  });
  addEventListener(configuration, xhr, 'error', function () {
    displayRemoteConfigurationFetchingError();
  });
  xhr.open('GET', buildEndpoint(configuration));
  xhr.send();
}
export function buildEndpoint(configuration) {
  return "https://sdk-configuration.".concat(buildEndpointHost('rum', configuration), "/").concat(REMOTE_CONFIGURATION_VERSION, "/").concat(encodeURIComponent(configuration.remoteConfigurationId), ".json");
}
function displayRemoteConfigurationFetchingError() {
  display.error('Error fetching the remote configuration.');
}